import store from '@/store'

const formatDate = (isoString, withTime = false) => {
  if (!isoString) return '-'
  const date = new Date(isoString)
  if (isNaN(date.getTime())) return '-'

  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'short',
    ...(withTime ? { timeStyle: 'short' } : {}),
    timeZone: store.getters['appSettings/timezone'] || 'UTC'
  }).format(date).replace(/\//g, '.').replace(', ', ' ')
}

export { formatDate }
